/* Mystery Vending – Theme JS */
(function () {
  'use strict';

  // ---- Cart count badge ----
  function updateCartCount(announceChange) {
    fetch('/cart.js')
      .then(r => r.json())
      .then(cart => {
        var count = cart.item_count;
        document.querySelectorAll('[data-cart-count]').forEach(el => {
          el.textContent = count;
          el.style.display = count > 0 ? 'inline-flex' : 'none';
        });
        // Update accessible name on the cart link
        document.querySelectorAll('a[href="/cart"]').forEach(link => {
          link.setAttribute('aria-label', 'Cart, ' + count + ' ' + (count === 1 ? 'item' : 'items'));
        });
        // Announce changes politely to screen readers
        if (announceChange) {
          var statusEl = document.querySelector('[data-cart-status]');
          if (statusEl) statusEl.textContent = 'Cart updated — ' + count + ' ' + (count === 1 ? 'item' : 'items') + '.';
        }
      });
  }

  // ---- Add to cart (product grid) ----
  document.addEventListener('submit', function (e) {
    const form = e.target.closest('form[data-add-to-cart]');
    if (!form) return;
    e.preventDefault();

    const btn = form.querySelector('[data-atc-btn]');
    const originalText = btn.textContent;
    btn.textContent = 'Adding…';
    btn.disabled = true;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: form.dataset.variantId, quantity: 1 })
    })
      .then(r => r.json())
      .then(() => {
        btn.textContent = 'Added!';
        updateCartCount(true);
        setTimeout(() => {
          btn.textContent = originalText;
          btn.disabled = false;
        }, 1400);
      })
      .catch(() => {
        btn.textContent = 'Error';
        btn.disabled = false;
      });
  });

  // ---- Variant selector (product page) ----
  const variantSelect = document.querySelector('[data-variant-select]');
  if (variantSelect) {
    variantSelect.addEventListener('change', function () {
      const selected = this.options[this.selectedIndex];
      const price = selected.dataset.price;
      const available = selected.dataset.available === 'true';
      const priceEl = document.querySelector('[data-product-price]');
      const atcBtn = document.querySelector('[data-product-atc]');

      if (priceEl && price) priceEl.textContent = formatMoney(parseInt(price));
      if (atcBtn) {
        atcBtn.disabled = !available;
        atcBtn.textContent = available ? 'Add to Cart' : 'Sold Out';
        // update hidden variant id
        document.querySelector('[name="id"]').value = selected.value;
      }
    });
  }

  // ---- Cart quantity update ----
  document.addEventListener('change', function (e) {
    const input = e.target.closest('[data-qty-input]');
    if (!input) return;
    const key = input.dataset.key;
    const qty = parseInt(input.value, 10);
    if (isNaN(qty)) return;
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(() => window.location.reload());
  });

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  updateCartCount();
})();

// Fade-in product cards on scroll
(function() {
  var observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry, i) {
      if (entry.isIntersecting) {
        // Stagger the animation slightly per card
        var delay = Array.prototype.indexOf.call(
          entry.target.parentElement.children, entry.target
        ) % 4 * 100;
        setTimeout(function() {
          entry.target.classList.add('is-visible');
        }, delay);
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.1 });

  document.querySelectorAll('.product-card').forEach(function(card) {
    observer.observe(card);
  });
})();